import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Lazy load translation resources
const loadTranslations = (language) => {
  return import(`./locales/${language}/translation.json`)?.then(module => module.default)?.catch(error => {
      console.error(`Failed to load ${language} translations:`, error);
      return {};
    });
};

i18n?.use(LanguageDetector)?.use(initReactI18next)?.init({
    resources: {}, // Start with empty resources
    fallbackLng: 'en',
    lng: localStorage.getItem('preferred_language') || 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false, // Disable suspense to prevent blocking
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    load: 'languageOnly',
    preload: false, // Don't preload languages
    partialBundledLanguages: true,
  });

// Load initial language asynchronously
const initLanguage = localStorage.getItem('preferred_language') || 'en';
loadTranslations(initLanguage)?.then(translations => {
  i18n?.addResourceBundle(initLanguage, 'translation', translations, true, true);
  if (i18n?.language !== initLanguage) {
    i18n?.changeLanguage(initLanguage);
  }
});

// Export function to load language on demand
export const loadLanguage = async (language) => {
  if (!i18n?.hasResourceBundle(language, 'translation')) {
    const translations = await loadTranslations(language);
    i18n?.addResourceBundle(language, 'translation', translations, true, true);
  }
  return i18n?.changeLanguage(language);
};

export default i18n;